module.exports = __webpack_public_path__ + "img/enterprise.21c368b2.png";